
<template>
  <div id="content">
    <popup v-show="hasPopup"
           :popup-type="getPopupType"
           :popup-action="getPopupAction"
           @popup-action="executePopupAction"></popup>
    <form autocomplete="off">
      <div class="inner">
        <p class="paging">
          <router-link :to="{ name: moduleName }" class="btn btn_back" v-translate>Seznam</router-link>
        </p>
        <p class="buttons">
          <a v-if="$_deleteActionAllowed && entity.custom_group" class="btn btn_action btn_delete" :title="'Smazat' | translate"
             @click.prevent.stop="deleteEntity" v-translate>Smazat</a>
        </p>
        <h1 v-translate>Přidat nový obrázek</h1>
      </div>
      <div class="responsiveTabs">
        <div class="tabs_content">
          <basic-form
              :entity="entity"
              :is-editable="editable"
              :is-edit="false"
              ref="imageformref"
          ></basic-form>
          <section class="buttons">
            <p>
              <router-link :to="{ name: moduleName }" class="btn btn_back btn_seznam" v-translate>Seznam
              </router-link>
              <input type="submit" :value="'Uložit' | translate"
                     v-if="editable"
                     :class="['btn']"
                     @click.prevent.stop="createImageEntity()">
            </p>
          </section>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import images from "./mixins/images";
import BasicForm from "./forms/BasicForm.vue";
import detailActions from "../../../components/mixins/detail-actions"


export default {
  name: "ImageNew",
  components: {BasicForm},
  mixins: [detailActions, images],
  data() {
    return {
      moduleName: 'images',
      entityName: "images",

      entity: {
        type: 'profile_images',
        uploadData: null,
      }
    }
  },
  created(ImageService) {
    this.entityService = ImageService
  },
  computed: {
    editable() {
      return this.$_createActionAllowed;
    },
  },
  methods: {
    createImageEntity(){
      const fd = new FormData();

      fd.append('uploaded_file', this.entity.uploadData);
      fd.append('type', this.entity.type);
      fd.append('id_selected_operator', this.entity.id_operator);


      this.entityService.createEntity(fd)
          .then(data => {
            this.saveLastVisited(data.id)
            this.setSuccessMessage();
            this.redirect(this.detailPageRouteName, {id: data.id})
          })
          .catch(function (error) {
            this.setErrorMessage(this._processDetailErrorMessage(error))
          }.bind(this))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/images/ImageNew.vue